// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WoeS","label":"styles_label__1blxv"};